module.exports = __webpack_public_path__ + "static/img/icon_fxcwfcx.444d693d.png";